import { useStaticQuery, graphql } from 'gatsby'

export const useCallout1Query = () => {
  const { wp } = useStaticQuery(graphql`
    query Callout1Query {
      wp {
        acfOptionsCommonItems {
          commonItems {
            callout1 {
              backgroundImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH)
                  }
                }
              }
              cutoutImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData(formats: WEBP, sizes: "(min-width: 1024px) 18vw, 39vw")
                  }
                }
              }
              cutoutImageAltText
              vanImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData(formats: WEBP, sizes: "(min-width: 1024px) 27vw, 79vw")
                  }
                }
              }
              vanImageAltText
              title
              buttonText
            }
          }
        }
      }
    }
  `)
  return wp.acfOptionsCommonItems.commonItems.callout1
}
